module.exports = __webpack_public_path__ + "static/media/bt-mic-off.0044a80c.svg";